import { render, staticRenderFns } from "./TabTaxDetailsInvoiceAp.vue?vue&type=template&id=8d469e86&"
import script from "./TabTaxDetailsInvoiceAp.vue?vue&type=script&lang=ts&"
export * from "./TabTaxDetailsInvoiceAp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d469e86')) {
      api.createRecord('8d469e86', component.options)
    } else {
      api.reload('8d469e86', component.options)
    }
    module.hot.accept("./TabTaxDetailsInvoiceAp.vue?vue&type=template&id=8d469e86&", function () {
      api.rerender('8d469e86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-payables/invoices-ap/TabTaxDetailsInvoiceAp.vue"
export default component.exports